import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import CloudinaryImage from '../common/CloudinaryImage';

import '../common/common.css';
import Container from './Container';

export default function TrustedClient({ clientlogo }) {
  return (
    <Container>
      {clientlogo?.titleEditor && (
        <div className="xl:mb-[34px] md:mb-[30px] mb-[0px]">
          {clientlogo?.title && (
            <p className="text-[#000000] md:text-[24px] text-[16px] font-[400] flex flex-wrap items-center">
              {clientlogo?.title}{' '}
              <span className="bg-[#000000] w-[60px] h-[2px] block ml-3"></span>
            </p>
          )}
          {clientlogo?.titleEditor && (
            <ReactMarkdown
              rehypePlugins={[rehypeRaw]}
              className={` font-[400] xl:text-[48px] md:text-[32px] text-[26px] title_hd leading-tight tracking-[-1px] max-w-[1100px]`}
              source={clientlogo?.titleEditor}
            >
              {clientlogo?.titleEditor}
            </ReactMarkdown>
          )}
        </div>
      )}
      <ul className="grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-3 grid-cols-1">
        {clientlogo?.Companies?.map((data, key) => (
          <li
            key={key}
            className="flex items-center sm:justify-start justify-center"
          >
            <div className="w-[150px] h-[120px] flex items-center justify-center">
              <CloudinaryImage
                backendImgUrl={data?.image?.data?.attributes?.url}
                alt={data?.image?.data?.attributes?.alternativeText}
                className="max-w-[160px] max-h-[110px]"
                type="icon"
              />
            </div>
          </li>
        ))}
      </ul>
    </Container>
  );
}
